
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EpbAnimatedBackground',
  setup() {
    const baseClass = 'epb-animated-background'

    return {
      baseClass,
    }
  },
})
